import { IconBookMarked } from "@teral/icons";
import { buttonVariants } from "../../../buttons/button";
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateHeader,
  EmptyStateTitle,
} from "../../../empty-state";

export const DataTableEmptyState = () => (
  <EmptyState frame="none">
    <EmptyStateHeader>
      <EmptyStateTitle>Nothing here yet</EmptyStateTitle>
      <EmptyStateDescription>
        Ready to get started? Check our documentation for a step-by-step guide.
      </EmptyStateDescription>
    </EmptyStateHeader>
    <EmptyStateActions>
      <a
        href="https://docs.teral.dev/introduction"
        target="_blank"
        rel="noopener noreferrer"
        className={buttonVariants({ variant: "outline", size: "md" })}
      >
        <IconBookMarked />
        Documentation
      </a>
    </EmptyStateActions>
  </EmptyState>
);
